<div
  *transloco="let t; prefix: 'configuration-tester-document-list-component'"
  class="configuration-tester-document-list__container"
  [class.fullscreen]="isFullscreen()"
>
  @if (isLoading()) {
    <div class="configuration-tester-document-list--loading">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }
  <div class="configuration-tester-document-list_header">
    @if (dataSource.hasData) {
      <!-- Expiration info moved to actions bar -->
    }
  </div>

  <div class="configuration-tester-document-list_actions">
    <xi-search-box
      [placeholder]="t('search')"
      [(ngModel)]="searchText"
      [isFiredOnEnter]="true"
      [hasOutline]="false"
      [stretch]="true"
      [disabled]="isDisabled()"
      textSize="small"
      (onCancelClick)="clearSearch()"
      (onChangeOverride)="onSearch()"
      ngDefaultControl
      name="evaluation-result-search"
      class="configuration-tester-document-list_actions-search"
    ></xi-search-box>

    <xi-default-button
      text="{{ fullscreenTooltip }}"
      fill="text"
      iconLeft="{{ fullscreenIcon }}"
      [disabled]="isDisabled()"
      (onClick)="toggleFullscreen()"
    ></xi-default-button>
    <xi-default-button
      text="{{ t('clear') }}"
      fill="text"
      iconLeft="cancel_circle"
      [disabled]="isDisabled()"
      (onClick)="clearResults()"
    ></xi-default-button>
    <xi-default-button
      text="{{ t('export') }}"
      fill="text"
      iconLeft="download"
      [disabled]="isDisabled()"
      [matMenuTriggerFor]="exportActionsTrigger"
    ></xi-default-button>

    <mat-menu class="configuration-tester-document-list_actions-export" #exportActionsTrigger>
      <div>
        <button mat-menu-item (click)="exportResults('xlsx')" [disabled]="isDisabled()">
          <xi-icon icon="download"></xi-icon>
          <div>{{ t('excel') }}</div>
        </button>
      </div>
      <div>
        <button mat-menu-item (click)="exportResults('csv')" [disabled]="isDisabled()">
          <xi-icon icon="download"></xi-icon>
          <div>{{ t('csv') }}</div>
        </button>
      </div>
    </mat-menu>

    @if (dataSource.hasData) {
      <xi-icon-button
        icon="clock_2"
        color="CX"
        [disabled]="isDisabled()"
        [ngbPopover]="extendTimePopover"
        popoverClass="configuration-tester-document-list__extend-time-popover"
        placement="bottom-right"
        [autoClose]="'outside'"
        triggers="click"
        #popover="ngbPopover"
        class="configuration-tester-document-list_extend-time"
      ></xi-icon-button>

      <ng-template #extendTimePopover>
        <div class="configuration-tester-document-list__extend-time-content">
          <div
            class="configuration-tester-document-list__expiration-text"
            [innerHTML]="t('test-data-expiration-text', { expirationDate: expirationDate })"
          ></div>

          <xi-default-button
            text="{{ t('extend-time') }}"
            fill="fill"
            buttonSize="small"
            (onClick)="extendResultsTime(); popover.close()"
          ></xi-default-button>
        </div>
      </ng-template>
    }
  </div>

  <div class="configuration-tester-document-list__table-wrapper">
    <cdk-virtual-scroll-viewport
      [itemSize]="VIRTUAL_SCROLL_ITEM_SIZE"
      class="configuration-tester-document-list__table-scroll-viewport"
      (scroll)="onTableScroll($event)"
    >
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        matSortDisableClear
        class="configuration-tester-document-list__table"
      >
        <tr mat-header-row *matHeaderRowDef="dataSource.displayColumns$ | async; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: dataSource.displayColumns$ | async"
          (click)="openDocument(row)"
        ></tr>

        <ng-container matColumnDef="documentId">
          <th mat-header-cell *matHeaderCellDef="let document" class="text">
            {{ t('document-id') }}
          </th>
          <td mat-cell matTooltip="{{ document.id }}" *matCellDef="let document">
            {{ document.documentId | truncate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="text">
          <th mat-header-cell *matHeaderCellDef="let document" class="text">
            <hr />
            {{ t('text') }}
          </th>
          <td mat-cell *matCellDef="let document">
            @if (document.highlightedSourceText) {
              <div [innerHTML]="document.highlightedSourceText"></div>
            } @else {
              {{ document.sourceText }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef="let document" class="text">
            <hr />
            {{ t('status') }}
          </th>
          <td mat-cell *matCellDef="let document">
            <div>
              <xi-icon
                [icon]="document.icon"
                [color]="document.color"
                class="configuration-tester-document-list__hit-icon"
              ></xi-icon>
              {{ t('status-value.' + document.status) }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="section">
          <th mat-header-cell *matHeaderCellDef="let document" class="text">
            <hr />
            {{ t('section') }}
          </th>
          <td mat-cell *matCellDef="let document">
            @if (document.sectionName) {
              {{ document.sectionName }}
            }
          </td>
        </ng-container>
      </table>
    </cdk-virtual-scroll-viewport>
  </div>

  <div
    class="configuration-tester-document-list_footer"
    [class.item-changed]="selectedItemChanged()"
  >
    @if (dataSource.hasData) {
      <div class="configuration-tester-document-list_footer-row">
        @if (dataSource.metrics?.hasComparison) {
          <div class="configuration-tester-document-list_footer-row-item">
            <xi-icon
              [icon]="RESULT_STATUS_INFO.ADDED.icon"
              [color]="RESULT_STATUS_INFO.ADDED.color"
            ></xi-icon>
            <div>
              <b>{{ dataSource.metrics?.added ?? 0 }}</b>
              {{ t('status-value.ADDED') }}
            </div>
          </div>

          <div class="configuration-tester-document-list_footer-row-item">
            <xi-icon
              [icon]="RESULT_STATUS_INFO.DIFFERENT_HIT.icon"
              [color]="RESULT_STATUS_INFO.DIFFERENT_HIT.color"
            ></xi-icon>
            <div>
              <b>{{ dataSource.metrics?.different ?? 0 }}</b>
              {{ t('status-value.DIFFERENT_HIT') }}
            </div>
          </div>

          <div class="configuration-tester-document-list_footer-row-item">
            <xi-icon
              [icon]="RESULT_STATUS_INFO.REMOVED.icon"
              [color]="RESULT_STATUS_INFO.REMOVED.color"
            ></xi-icon>
            <div>
              <b>{{ dataSource.metrics?.removed ?? 0 }}</b>
              {{ t('status-value.REMOVED') }}
            </div>
          </div>

          <div class="configuration-tester-document-list_footer-row-item">
            <xi-icon
              [icon]="RESULT_STATUS_INFO.UNCHANGED.icon"
              [color]="RESULT_STATUS_INFO.UNCHANGED.color"
            ></xi-icon>
            <div>
              <b>{{ dataSource.metrics?.unchanged ?? 0 }}</b>
              {{ t('status-value.UNCHANGED') }}
            </div>
          </div>

          <xi-icon
            [icon]="RESULT_STATUS_INFO.DIDNT_HIT.icon"
            [color]="RESULT_STATUS_INFO.DIDNT_HIT.color"
          ></xi-icon>
          <div>
            <b>{{ dataSource.metrics?.missed ?? 0 }}</b>
            {{ t('status-value.DIDNT_HIT') }}
          </div>

          <ng-container *ngTemplateOutlet="errorStatus; context: { t: t }"></ng-container>
        } @else {
          <xi-icon
            [icon]="dataSource.metrics?.hits ? 'circle_check_filled' : 'cancel_circle_filled'"
            [color]="dataSource.metrics?.hits ? 'success' : 'error'"
          ></xi-icon>
          <div>
            <b>{{ dataSource.metrics?.hits ?? 0 }}</b>
            {{ t('status-value.HIT') }}
          </div>

          <xi-icon
            [icon]="RESULT_STATUS_INFO.DIDNT_HIT.icon"
            [color]="RESULT_STATUS_INFO.DIDNT_HIT.color"
          ></xi-icon>
          <div>
            <b>{{ dataSource.metrics?.missed ?? 0 }}</b>
            {{ t('status-value.DIDNT_HIT') }}
          </div>

          <ng-container *ngTemplateOutlet="errorStatus; context: { t: t }"></ng-container>
        }
      </div>

      @if (selectedItemChanged()) {
        <div class="configuration-tester-document-list_footer-row row-rerun">
          <xi-icon icon="refresh" color="CX"></xi-icon>
          <b>{{ t('rerun-test-text') }}</b>
        </div>
      }
    }
  </div>
</div>

<ng-template #errorStatus let-t="t">
  @if (dataSource.metrics?.errors > 0) {
    <div class="configuration-tester-document-list_footer-row-item">
      <xi-icon
        [icon]="RESULT_STATUS_INFO.ERROR.icon"
        [color]="RESULT_STATUS_INFO.ERROR.color"
      ></xi-icon>
      <div>
        <b>{{ dataSource.metrics?.errors ?? 0 }}</b>
        {{ t('status-value.ERROR') }}
      </div>
    </div>
  }
</ng-template>

@if (showDocumentViewModal()) {
  <app-lex-xi-modal
    [isVisible]="showDocumentViewModal()"
    [canBackdropClose]="false"
    maxWidth="80vw"
    (close)="onDocumentViewModalClosed()"
  >
    <ng-template appXIModalContent>
      @if (showDocumentViewModal()) {
        <app-document-view-dialog
          [options]="documentViewModalOptions()"
          (modalClosed)="onDocumentViewModalClosed()"
        ></app-document-view-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
